//=====================================================
//　エラーメッセージ（画面上部）
//=====================================================

interface IFProps {
    text: string
}

export function MsgBoxErr(props:IFProps){

    return (
        <div className="messagebox-error">{props.text}</div>
    )

}